// extracted by mini-css-extract-plugin
export default {"awards":"Awards_awards__Mc4f6","skeleton":"Awards_skeleton__lQ9GU","image":"Awards_image__GMJvK"};